<template>
    <div class="ini-commentitem">
        <ini-avatar :record="handledby.value"/>
        <div class="ini-commentitem__content">
            <div class="ini-commentitem__header">
                <span v-if="!isCurrentUser" class="ini-commentitem__star"
                      :class="{'ini-commentitem__star--currentuser': !isCurrentUser}"><i
                        class="zmdi zmdi-star-circle"></i></span>
                <span class="ini-commentitem__title" :class="{'ini-commentitem__title--currentuser': !isCurrentUser}">{{ getHandledByFullName }}</span>
                <span class="ini-commentitem__datetime">{{ transformCreatedTime}}</span>
            </div>
            <div class="ini-commentitem__body">
                <p v-html="body"></p>
            </div>
            <div class="ini-commentitem__attachments" v-if="attachments.length > 0">
                <span>{{ $t('LBL_ATTACHED_FILES') }}</span>
                <ini-attachment v-for="(attachment, index) in attachments" v-bind:key="index" v-bind="attachment"
                                @click="attachmentClicked(attachment)"/>
            </div>
        </div>
    </div>
</template>

<script>
    import IniAvatar from '@/components/Avatar'
    import IniAttachment from '@/components/Attachment'
    import AppMixin from "@/mixins/AppMixin";

    export default {
        mixins: [AppMixin],
        props: {
            body: String,
            isCurrentUser: Boolean,
            createdtime: {
                type: Object,
                default: () => ({value: '', displayValue: ''})
            },
            handledby: {
                type: Object,
                default: () => ({value: '', displayValue: ''})
            },
            attachments: {
                type: Array,
                default: () => []
            }
        },

        components: {
            IniAvatar,
            IniAttachment
        },

        computed: {
            getHandledByFullName() {
                let fullName = this.handledby.displayValue

                if (fullName) {
                    fullName = fullName.trim()
                }

                return fullName
            },
            transformCreatedTime() {
                return this.getLocaltime(this.createdtime.value)
            }
        },

        methods: {
            attachmentClicked(attachment) {
                this.$emit('attachment-clicked', attachment)
            },
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/components/HelpDesk/Comment/_commentitem.scss";</style>